import React, { useEffect, useState } from "react";
import "./Events.css";
import FeaturedEvent from "../FeaturedEvent";
import UpcomingEvents from "../UpcomingEvents";
import Newsletter from "../Newsletter";
import Footer from "../Footer";

const Events = () => {
  const [featuredSlug, setFeaturedSlug] = useState(null);

  useEffect(() => {
    fetch("https://beszeljegyesulet.hu/wp/wp-json/wp/v2/events?per_page=1")
      .then((res) => res.json())
      .then((data) => {
        if (data.length > 0) setFeaturedSlug(data[0].slug);
      })
      .catch(() => {});
  }, []);

  return (
    <main className="events-page">
      <section className="events-intro">
        <h1>Gyere el eseményeinkre!</h1>
        <p>
          Csatlakozz közelgő eseményeinkhez, konferenciáinkhoz, találkozóinkhoz és sok
          máshoz. Akár egy képernyőre, akár egy hozzád közeli városba érkezünk,
          mindenki talál magának valót.
        </p>
      </section>
      <FeaturedEvent />
      <UpcomingEvents featuredSlug={featuredSlug} />
      <Newsletter />
      <Footer />
    </main>
  );
};

export default Events;